<div
  class="load-item sub-item delivered"
  [ngClass]="
    load.isCancelled
      ? 'cancelled'
      : !loadStatus?.statusCode
      ? 'not_received'
      : loadStatus?.statusCode === sCode.S31
      ? 'finished'
      : loadStatus?.current || loadStatus?.acceptanceType === loadStatusAcceptanceType.Current
      ? 'current'
      : 'received'
  "
>
  <div class="expansion-panel-point"></div>
  <mat-expansion-panel [expanded]="loadStatus?.acceptanceType === loadStatusAcceptanceType.Current">
    <mat-expansion-panel-header>
      <div class="load-item__header">
        <div>
          <a
            [routerLink]="'/dashboard/shipment-load/main-info'"
            [queryParams]="{
              loadNumber: load.loadNumber,
              monitoringPageType: monitoringPageType,
            }"
          >
            <span class="load-item__number sub-item__number nowrap" cropText>
              {{ 'load.title' | translate }}
              #{{ load.loadNumber }}
            </span>
          </a>
        </div>
        <ng-content select="[header]"></ng-content>
      </div>
    </mat-expansion-panel-header>

    <div class="page-body tw-flex">
      <ng-content select="[body]"></ng-content>
    </div>
  </mat-expansion-panel>
</div>
